import { css } from '@emotion/react';

/**
 *  font style
 * @param {string} fontWeight 폰트두께
 * @param {string} fontSize 폰트 크기
 * @param {string} lineHeight 언더라인 기준으로부터의 높이
 * @param {string} color 폰트 색상
 *  */
export const fontFrame = (
  fontWeight: string,
  fontSize: string,
  lineHeight: string,
  color: string
) => css`
  font-weight: ${fontWeight};
  font-size: ${fontSize};
  line-height: ${lineHeight};
  color: ${color};
  /* font-family: 'Noto Sans KR', sans-serif;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal; */
`;
